module.exports = __webpack_public_path__ + "img/emb.632efcb6.svg";